import { Outlet, Link } from 'react-router-dom';
import ThemeToggle from '@/components/ThemeToggle';
import AppFooter from '@/components/AppFooter';
import CityLogo from '@/components/CityLogo';

export default function AuthLayout() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-primary-50 via-white to-accent-50 dark:from-[#1b1b1f] dark:via-[#1e1e22] dark:to-[#1b1b1f] px-4 transition-colors">
      {/* Theme Toggle */}
      <div className="fixed top-4 right-4 z-50">
        <ThemeToggle />
      </div>

      {/* Logo */}
      <Link to="/" className="flex items-center gap-2 mb-8 no-underline">
        <CityLogo size={48} variant="glow" />
        <span className="text-2xl font-bold text-surface-900 dark:text-white">React-City</span>
      </Link>

      {/* Auth card */}
      <div className="w-full max-w-md">
        <div className="card animate-in">
          <Outlet />
        </div>

        <p className="text-center text-xs text-surface-400 dark:text-surface-500 mt-6">
          Il Movimento del Dono — Mutuo sostegno comunitario
        </p>
      </div>

      {/* Footer */}
      <div className="absolute bottom-0 left-0 right-0">
        <AppFooter />
      </div>
    </div>
  );
}
